import type { RefObject } from "react";
import type { MentionCompletionState } from "../../hooks/useMentions";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { GhostText } from "./GhostText";
import { MentionMenu } from "./MentionMenu";

type Props = {
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  value: string;
  isTextareaFocused: boolean;
  completion: MentionCompletionState;
};

export function MentionCompletion({
  textareaRef,
  value,
  isTextareaFocused,
  completion,
}: Props) {
  // While browsing (no query) the catalog shows a popular sample; the nudge
  // hints that typing searches the whole catalog.
  const showSearchNudge =
    completion.token?.query === "" && completion.catalogTotal > 0;

  return (
    <>
      <GhostText
        textareaRef={textareaRef}
        value={value}
        caret={completion.caret}
        suffix={completion.suffix}
      />
      {isTextareaFocused &&
        completion.token &&
        completion.matches.length > 0 && (
          <MentionMenu
            textareaRef={textareaRef}
            value={value}
            slashStart={completion.token.start}
            items={completion.matches}
            selectedIndex={completion.selectedIndex}
            onSelect={completion.onSelect}
            footer={
              showSearchNudge ? (
                <>
                  <Icon name="search" size={12} style={{ flexShrink: 0 }} />
                  <Text variant="text-small" ellipsis>
                    Search {completion.catalogTotal.toLocaleString("en-US")}{" "}
                    connectors
                  </Text>
                </>
              ) : undefined
            }
          />
        )}
    </>
  );
}
